import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {AlertifyService} from 'jul-web-shared-lib/src/lib/components/alertify';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { Subscription } from 'rxjs';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { PaginationCriteria } from 'jul-web-shared-lib';
import { Notification } from '../core/models/notifications/notification.model';
import { NotificationService } from '../core/services/notifications/notification.service';
import * as moment from 'moment';
import * as _ from "lodash";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {

  subscription$: Subscription = new Subscription();
  notificationsData:any;
  timer: TimerObservable<any>;
  isLoaded = false;
  loading = false;
  error = false;
  opened = false;
  maxResults = 5;
  upToDate = false;
  unreadNotifications: number = null;
  criteria = new PaginationCriteria<Notification>(this.maxResults, [{
    "direction": "DESC",
    "attribute": "screenDate"
  }], {}, this.maxResults, 1);
  private subscription: Subscription;

  @ViewChild('ps') perfectScrollbar: PerfectScrollbarComponent;
  audio = new Audio('assets/sounds/notification-sound.mp3');

  constructor(private notificationService: NotificationService,
              private cdr: ChangeDetectorRef,
              private alertifyService: AlertifyService) { }

  ngOnInit() {
    this.criteria.filters.userId = {};
    this.criteria.filters.archived = false;

    this.notificationService.getPaginated(this.criteria).subscribe(not => {
      setTimeout(() => {

        if (not && not.results) {
          this.notificationsData =  not.results;
        }
        this.cdr.detectChanges();
      }, 700);
    },
    error => {
      setTimeout(() => {
        this.loading = false;
        this.error = true;
      }, 600);
    });

    this.timer = TimerObservable.create(0, 50000);
    this.subscription$ = this.timer.subscribe(t => {
      this.getUnreadNotifications();
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openNotification() {
    if (this.opened) {
      this.loadNotifications();
    }
  }
  get unReadNotifications() {
    return this.unreadNotifications;
  }

  onHidden(): void {
    this.opened = false;
  }
  onShown(): void {
    this.opened = true;
  }
  navigate(notification: Notification) {
    let url = notification.url;
    if (url){
      this.markAsRead(notification, true);
    }
  }

  markAsRead(notification: Notification, navigate?){
    if(!notification.read){
      this.notificationService.read(notification.id).subscribe((n:any)=> {
        notification.read= true;
        notification.versionNumber = n.data.versionNumber;
        this.unreadNotifications--;

        if (navigate){
          var baseRef = environment.server;

          if (!baseRef.endsWith("/")) {
            baseRef += "/";
          }

          window.location.href = baseRef + notification.url;
        }

        this.cdr.detectChanges();
      },
      error=>{
        this.alertifyService.error(error);
      });
    } else if (navigate){
      var baseRef = environment.server;

      if (!baseRef.endsWith("/")) {
        baseRef += "/";
      }

      window.location.href = baseRef + notification.url;
    }
  }

  markAsUnread(notification: Notification) {
    if (notification.read) {
      this.notificationService.unread(notification.id).subscribe((n: any) => {
        notification.read = false;
        notification.versionNumber = n.data.versionNumber;
        this.unreadNotifications++;
        this.cdr.detectChanges();
      },
      error => {
        this.alertifyService.error(error);
      });
    }
  }


  getUnreadNotifications() {
    this.notificationService.getCount().subscribe((resp)=> {
      if (this.isLoaded && this.unreadNotifications!=resp.total){
        this.loadNotifications();
      }
      if (resp.beep){
        this.audio.play();
      }

      this.unreadNotifications = resp.total;
      this.cdr.detectChanges();
    },
    error=>{}
    );
  }

  loadNotifications() {
    this.loading = true;
    this.error = false;
    this.cdr.detectChanges();
    this.notificationService.getPaginated(this.criteria).subscribe(not => {
      setTimeout(() => {
        if (not && not.results) {
          this.notificationsData =  not.results;
        }
        let index = 0;
        this.notificationsData.forEach(element => {
          this.notificationsData[index].date =  moment(this.notificationsData[index].screenDate).format('YYYY-MM-DD');
          this.notificationsData[index].time =  moment(this.notificationsData[index].screenDate).format('HH:mm:ss');
          index++;
        });
        this.notificationsData = _.groupBy(this.notificationsData, 'date');
        let keys = [];
        for (let key in this.notificationsData) {
            keys.push({key: this.checkDate(key), value: this.notificationsData[key]});
        }
        this.notificationsData = keys;

        this.isLoaded = true;
        this.loading = false;
        this.cdr.detectChanges();
      }, 600);
    },
    error => {
      setTimeout(() => {
        this.loading = false;
        this.error = true;
      }, 600);
    });
  }


  checkDate(date: any){
    var a = new Date(date);
    var yesterday = new Date();
    var today = new Date();
    yesterday.setDate(today.getDate() - 1);

    a = this.removeTime(a);
    yesterday = this.removeTime(yesterday);
    today = this.removeTime(today);

    if (a.getTime() == today.getTime())
      return "generic.label.today";
    else if (a.getTime() == yesterday.getTime())
      return "generic.label.yesterday";
    else
      return moment(date).format('DD-MM-YYYY');
  }

  removeTime(date: any){
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0, 0);
    return date;
  }

  openNotificationsPage(){
    var baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }
    let path = 'web/#/notifier/nt/notifications';

    window.location.href = baseRef + path;
  }


}
